
<template>
  <div v-wechat-title="titleTop" class="body">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="addressRect" v-if="!data.isAllVirtually">
      <div v-if="!address" class="select" @click="onAddressChange(false)">
        <div class="input">请选择收件人
        </div>
        <div class="button">
          <i class="iconfont iconquit" />
        </div>
      </div>
      <div v-if="address" class="select" @click="onAddressChange(true)">
        <div class="name">
          {{ address.name }} {{ address.phone }}
        </div>
        <div class="address">
          {{ address.zipString }}{{ address.address }}
        </div>
        <div class="button">
          <i class="iconfont iconquit" />
        </div>
      </div>
    </div>
    <div class="payType">
      <van-row>
        <van-col span="12">支付方式</van-col>
        <van-col span="12" class="rigth"><div @click="onSelectPayType">{{ selectPayType ?selectPayType.text:'请选择' }} <i class="iconfont icongengduo" /></div></van-col>
      </van-row>
    </div>
    <div class="commoditys">
      <div class="title">
        <i class="iconfont iconshangdian" /> {{ GetSysTitle() }}
      </div>
      <div v-if="data" class="icon">
        <div v-for="(item,index) in data.commoditys" :key="index">
          <div class="commodityRect">
            <van-image
              width="4em"
              height="4em"
              :src="showCommoditysIcon(item)"
              @click="onShowItemOrImage(item)"
            />
            <div class="info">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="specification">
                <van-tag v-if="item.diyData" plain type="danger" :color="GetColorMain()">{{ cutString(item.diyData.title,10) }}</van-tag>
                {{ item.specificationMainName }}
                <template v-if="item.specificationOtherNames">
                  <span v-for="sp in item.specificationOtherNames.split('/')" :key="sp">
                    {{ sp }}
                  </span>
                </template>
              <!-- <span v-if="item.tripBeginTime && !item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}</span>
              <span v-if="item.tripBeginTime && item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}~{{ formatDate(item.tripEndTime,"yyyy/MM/dd") }}</span> -->
              </div>
              <div class="prices">
                <van-row>
                  <van-col span="12" class="priceItem" :style="'color: '+GetColorMain()">
                    <template v-if="item.stepBuy === 'SECOND_CNY'">
                      ￥<span>{{ parseInt(item.stepPrice) }}</span>.{{ ("0"+parseInt((100*item.stepPrice+0.5-100*parseInt(item.stepPrice)))).slice(-2) }}
                    </template>
                    <template v-if="item.stepBuy !== 'SECOND_CNY'">
                      ￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}
                    </template>
                  </van-col>
                  <!-- <van-col span="12">{{ item.price }}</van-col> -->
                  <van-col span="12" class="rigth">x{{ item.num }}</van-col>
                </van-row>
              </div>
            </div>
          </div>
          <!-- <van-row>
          <van-col span="16">

          </van-col>
          <van-col span="8" class="rigth num">共3件 <i class="iconfont iconquit" /></van-col>
        </van-row> -->
          <div v-if="item.isNeedContacts" class="extebdedRect">
            <van-row class="line">
              <van-col span="14">
                出行日期：
                <span v-if="item.tripBeginTime && !item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}</span>
                <span v-if="item.tripBeginTime && item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}~{{ formatDate(item.tripEndTime,"yyyy/MM/dd") }}</span>
                <span v-if="!item.tripBeginTime && !item.tripEndTime"><b :style="'color: '+GetColorMain()">未选择</b></span>
              </van-col>
              <van-col span="10" class="rigth"><van-button type="danger" size="small" plain round :color="GetColorMain()" @click="onClickDatePlan(index,item)">修改出行日期</van-button></van-col>
            </van-row>
            <van-row class="line">
              <van-col span="14">
                出 行 人 ：添加<b :style="'color: '+GetColorMain()">{{ item.num }}位</b>出行人
              </van-col>
              <van-col span="10" class="rigth"><van-button type="danger" size="small" plain round :color="GetColorMain()" @click="onClickContacts(index,item)">选择出行人</van-button></van-col>
            </van-row>
            <van-row v-if="item.customerInfo && item.customerInfo.length>0" class="line">
              <van-col v-for="customerInfo in item.customerInfo" :key="customerInfo.customerLogId" span="24">
                <i class="iconfont iconshanchuround" :style="'color: '+GetColorMain()" @click="onClickRemoveCustomer(index,customerInfo.customerLogId)" />
                {{ customerInfo.lastName }} {{ customerInfo.firstName }} {{ customerInfo.phone }}
              </van-col>
            </van-row>
          </div>
        </div>

      </div>
    </div>
    <div class="traffic">
      <van-row>
        <van-col span="6">配送

        </van-col>
        <van-col span="18" class="rigth" v-if="CheckSystemType('DiveBoss')">
          <span v-if="data.freightStrategy === 'NONE'">无需配送</span>
          <span v-if="data.freightStrategy === 'CASH_ON_DELIVERY'">货到付款</span>
          <span v-if="data.freightStrategy === 'FULL_AMOUNT_FREE'">满{{ parseInt(data.LowFreeFreigthValue+0.5) }}元包邮</span>
          <span v-if="data.freightStrategy === 'FULL_PIECE_FREE'">满{{ data.LowFreeFreigthValue }}件包邮</span>
          <span v-if="data.freightStrategy === 'CASH_FIRST'">预付运费</span>
          <span v-if="data.freightStrategy === 'FREE'">包邮</span>
        </van-col>
        <van-col span="18" class="rigth" v-if="CheckSystemType('SSI')">
          <span v-if="data.freightStrategy === 'NONE'">无需配送</span>
          <span v-if="data.freightStrategy === 'CASH_ON_DELIVERY'">货到付款</span>
          <span v-if="data.freightStrategy === 'FULL_AMOUNT_FREE' && data.freightPrice>0 || !address">满{{ parseInt(data.LowFreeFreigthValue+0.5) }}元包邮</span>
          <span v-if="data.freightStrategy === 'FULL_AMOUNT_FREE' && data.freightPrice===0 && address">顺丰到付</span>

          <span v-if="data.freightStrategy === 'FULL_PIECE_FREE' && data.LowFreeFreigthValue>0 || !address">满{{ data.LowFreeFreigthValue }}件包邮</span>
          <span v-if="data.freightStrategy === 'FULL_PIECE_FREE' && data.LowFreeFreigthValue===0 && address">顺丰到付</span>
          
          <span v-if="data.freightStrategy === 'CASH_FIRST'">预付运费</span>
          <span v-if="data.freightStrategy === 'FREE'">包邮</span>
        </van-col>
      </van-row>
    </div>
    <div class="gifts">
      <van-row>
        <van-col span="12" @click="onShowCoupon">优惠券</van-col>
        <van-col span="12" class="rigth">
          <div v-if="selectCouponPrice>0" @click="onShowCoupon">已使用{{ selectCouponCommodityNum }}张优惠券<i class="iconfont icongengduo" /></div>
          <!-- <div v-if="selectCouponPrice>0" @click="onShowCoupon">优惠{{ selectCouponPrice.toFixed(2) }}元 <i class="iconfont iconquit" /></div> -->
          <div v-if="selectCouponPrice<=0 && couponData.list.length>0" @click="onShowCoupon">{{ couponData.list.length }}张可用 <i class="iconfont icongengduo" /></div>
          <div v-if="selectCouponPrice<=0 && couponData.list.length<=0" @click="onShowCoupon">无可用</div>
        </van-col>
      </van-row>
      <!-- <van-row>
        <van-col span="12">礼品卡</van-col>
        <van-col span="12" class="rigth">无可用 <i class="iconfont iconquit" /></van-col>
      </van-row>
      <van-row>
        <van-col span="21">积分 共1234积分，可用1000积分，抵10.00元</van-col>
        <van-col span="3" class="rigth">
          <van-switch
            v-model="checkedScore"
            size="1.4em"
          />
        </van-col>
      </van-row> -->
    </div>
    <div class="remark">
      <van-row>
        <van-col span="6">备注</van-col>
        <van-col span="18">
          <van-field v-model="orderRemark" placeholder="备注信息" style="font-size:1em;" type="textarea" rows="1" input-align="right" autosize maxlength="1024" />
        </van-col>
      </van-row></div>

    <!-- <div v-if="data && data.commoditys && data.commoditys.length>0 && data.commoditys[0].stepBuy!=='NONE'" class="price">
      <van-row>
        <van-col span="16">尾款</van-col>
        <van-col span="8" class="rigth">
          <template v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">
            ￥{{ ShowMoney(data.commoditys[0].price-data.couponPrice) }}
            <div v-if="data.couponPrice != 0" class="aboutStr">(尾款已优惠￥{{ ShowMoney(data.couponPrice) }})</div>
          </template>
          <template v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">
            {{ data.commoditys[0].stepCurrency }} {{ ShowMoney(data.commoditys[0].stepPrice) }}
          </template>
        </van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">
        <van-col span="12">尾款支付时间</van-col>
        <van-col span="12" class="rigth">{{ formatDate(data.commoditys[0].stepPayTime,"yyyy/MM/dd hh:mm:ss",false) }}</van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">
        <van-col span="8">尾款支付</van-col>
        <van-col span="16" class="rigth">线下现场现付
          <div class="aboutStr">现付方式以商家要求为准，通常为<br>现金(当地货币),刷卡需承担手续费</div>
        </van-col>
      </van-row>
    </div> -->
    <div v-if="data && data.commodityPrice && isStepBuy" class="price">
      <van-row>
        <van-col span="16">商品金额</van-col>
        <van-col span="8" class="rigth">￥{{ ShowMoney(data.commodityPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.couponPrice != 0">
        <van-col span="16">优惠券</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.couponPrice) }}</van-col>
      </van-row>

      <van-row v-if="data.freightPrice != 0 && data.LowFreeFreigthValue - data.totalPriceFreight > 0 && data.freightStrategy === 'FULL_AMOUNT_FREE'">
        <van-col span="16">运费
          <span class="freePayPrice">(还差{{ ShowMoney(data.LowFreeFreigthValue - data.totalPriceFreight) }}元免运费)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0 && data.freightStrategy === 'FULL_PIECE_FREE'">
        <van-col span="16">运费
          <span class="freePayPrice">(还差{{ parseInt(data.LowFreeFreigthValue - data.totalNum) }}件免运费)</span>
          <span v-if="data.freightStrategy === 'CASH_FIRST'" class="freePayPrice">(预付运费，多退少补)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0 && data.freightStrategy === 'CASH_FIRST'">
        <van-col span="16">运费
          <span class="freePayPrice">(预付运费，多退少补)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.agentPrice != 0">
        <van-col span="16">佣金直返</van-col>
        <van-col span="8" class="rigth">
          <span v-if="data.agentPrice>0">+</span><span v-else>-</span> ￥{{ ShowMoney(Math.abs(data.agentPrice)) }}
        </van-col>
      </van-row>
      <van-row v-if="data.reductionPrice != 0">
        <van-col span="16">调价</van-col>
        <van-col span="8" class="rigth">
          <span v-if="data.reductionPrice>0">+</span><span v-else>-</span> ￥{{ ShowMoney(Math.abs(data.reductionPrice)) }}
        </van-col>
      </van-row>
      <van-row v-if="data.scorePrice != 0">
        <van-col span="16">积分抵扣</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.scorePrice) }}</van-col>
      </van-row>
      <van-row v-if="data.payPriceTotal != 0">
        <van-col span="16">支付手续费<span class="freePayPrice">(更换支付方式无手续费)</span></van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.payPriceTotal) }}</van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">
        <van-col span="16">总计</van-col>
        <van-col span="8" class="rigth">￥{{ ShowMoney(data.totalPriceForAll) }}</van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">
        <van-col span="8">总计</van-col>
        <van-col span="16" class="rigth">￥{{ ShowMoney(data.totalPrice) }} + {{ data.commoditys[0].stepCurrency }} {{ ShowMoney(data.commoditys[0].stepPrice*data.commoditys[0].num) }}</van-col>
      </van-row>
      <div class="stepPayRect">
        <div class="stepPayIconRect">
          <div class="stepPayIcon1" /><div class="stepPayIcon2" /><div class="stepPayLine" />
        </div>
        <div class="stepPayInfoRect">
          <van-row>
            <van-col span="19" class="stepPayRect">
              <div v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'" :style="'color: '+GetColorMain()">
                定金：￥{{ ShowMoney(data.commoditys[0].stepPrice*data.commoditys[0].num+data.payPrice) }}
                <template v-if="data.payPrice != 0"> (已含支付手续费{{ ShowMoney(data.payPrice) }}元)</template>
              </div>
              <div v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'" :style="'color: '+GetColorMain()">
                定金：￥{{ ShowMoney(data.totalPrice) }}
                <template v-if="data.payPrice != 0"> (已含支付手续费{{ ShowMoney(data.payPrice) }}元)</template>
              </div>
              <div v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">尾款：￥{{ ShowMoney(data.totalPriceForAll-data.commoditys[0].stepPrice*data.commoditys[0].num-data.payPrice) }}
                <template v-if="data.payPrice != 0"> (已含支付手续费{{ ShowMoney(data.payPriceTotal-data.payPrice) }}元)</template>
              </div>
              <div v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">尾款： {{ data.commoditys[0].stepCurrency }} {{ ShowMoney(data.commoditys[0].stepPrice*data.commoditys[0].num) }}
                <span>(约合:￥{{ ShowMoney(data.commoditys[0].stepPriceCNY*data.commoditys[0].num) }})</span>
              </div>
            </van-col>
            <van-col span="5" class="stepPayRect rigth payState">
              <span>待付款</span>

            </van-col>
          </van-row>
        </div>
      </div>

      <!-- <van-steps direction="vertical" :active="-1">
        <van-step v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">定金:
          ￥{{ ShowMoney(data.commoditys[0].stepPrice) }}
        </van-step>
        <van-step>尾款:</van-step>
      </van-steps> -->
    </div>
    <div v-if="data && data.commodityPrice && !isStepBuy" class="price">
      <van-row>
        <van-col span="16">商品金额</van-col>
        <van-col span="8" class="rigth">￥{{ ShowMoney(data.commodityPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0 && data.LowFreeFreigthValue - data.totalPriceFreight > 0 && data.freightStrategy === 'FULL_AMOUNT_FREE'">
        <van-col span="16">运费
          <span class="freePayPrice">(还差{{ ShowMoney(data.LowFreeFreigthValue - data.totalPriceFreight) }}元免运费)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0 && data.freightStrategy === 'FULL_PIECE_FREE'">
        <van-col span="16">运费
          <span class="freePayPrice">(还差{{ parseInt(data.LowFreeFreigthValue - data.totalNum) }}件免运费)</span>
          <span v-if="data.freightStrategy === 'CASH_FIRST'" class="freePayPrice">(预付运费，多退少补)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0 && data.freightStrategy === 'CASH_FIRST'">
        <van-col span="16">运费
          <span class="freePayPrice">(预付运费，多退少补)</span>
        </van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.agentPrice != 0">
        <van-col span="16">佣金直返</van-col>
        <van-col span="8" class="rigth">
          <span v-if="data.agentPrice>0">+</span><span v-else>-</span> ￥{{ ShowMoney(Math.abs(data.agentPrice)) }}
        </van-col>
      </van-row>
      <van-row v-if="data.reductionPrice != 0">
        <van-col span="16">调价</van-col>
        <van-col span="8" class="rigth">
          <span v-if="data.reductionPrice>0">+</span><span v-else>-</span> ￥{{ ShowMoney(Math.abs(data.reductionPrice)) }}
        </van-col>
      </van-row>
      <van-row v-if="data.couponPrice != 0 && data.commoditys[0].stepBuy !== 'SECOND_CNY'">
        <van-col span="16">优惠券</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.couponPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.scorePrice != 0">
        <van-col span="16">积分抵扣</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.scorePrice) }}</van-col>
      </van-row>
      <van-row v-if="data.payPrice != 0">
        <template v-if="selectPayType && !selectPayType.isFreePayPrice">
          <van-col span="16">支付手续费<span class="freePayPrice">(更换支付方式无手续费)</span></van-col>
          <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.payPrice) }}</van-col>
        </template>
        <template v-if="selectPayType && selectPayType.isFreePayPrice">
          <van-col span="16"><s>支付手续费</s><span class="freePayPrice">(活动期间免收支付手续费)</span></van-col>
          <van-col span="8" class="rigth"><s>+ ￥{{ ShowMoney(data.payPrice) }}</s></van-col>
        </template>

      </van-row>
    </div>

    <div class="emptyRect" />
    <div class="toolBar">
      <van-row>
        <van-col span="16" class="priceAll" :style="'color: '+GetColorMain()">￥<span>{{ parseInt(data.totalPrice) }}</span>.{{ ("0"+parseInt((100*data.totalPrice+0.5-100*parseInt(data.totalPrice)))).slice(-2) }}</van-col>
        <van-col span="8" class="rigth"><van-button type="danger" square style="height: 48px;width:100%;" :loading="loadingButton" :color="GetColorMain()" @click="onSubmitOrder">提交订单</van-button></van-col>
      </van-row>
      <!-- <div v-if="address" class="addressSelect">
        {{ address.zipString }} {{ address.address }}
      </div> -->
    </div>
    <van-popup v-model="showPayType" position="bottom">
      <van-picker
        show-toolbar
        title="支付方式"
        :columns="columnsPayType"
        @cancel="onCancel"
        @confirm="onConfirmPayType"
      />
    </van-popup>
    <van-popup v-model="showCoupon" position="bottom">
      <div class="couponRect">
        <van-row class="title">
          <van-col span="12">优惠券</van-col>
          <van-col span="12" class="rigth"><i class="iconfont iconquit" @click="showCoupon=false" /></van-col>
        </van-row>
        <van-tabs v-model="couponType">
          <van-tab :title="'可用优惠券('+couponData.list.length+')'" name="available">
            <div v-if="radioCoupon.length<=0" class="tips">请选择优惠券</div>
            <div v-if="radioCoupon.length>0" class="tips">已选择{{ radioCoupon.length }}张优惠券,{{ couponData.totalCouponNum }}件商品共抵扣<span class="mainColor">￥{{ couponData.totalCouponPrice.toFixed(2) }}</span></div>
            <van-checkbox-group v-model="radioCoupon" class="listAvailable" @change="onCouponChange">

              <div v-for="item in couponData.list" :key="item.couponId" class="rect">
                <van-row class="infos">
                  <van-col span="7">
                    <div v-if="item.discountPercentage!==null" class="money" :style="'color: '+GetColorMain()"><span>{{ (item.discountPercentage*0.1).toFixed(1) }}</span>折</div>
                    <div v-if="item.realPrice!==null" class="money" :style="'color: '+GetColorMain()"><span>{{ item.realPrice.toFixed(2) }}</span>元</div>
                    <div v-if="item.discountPrice!==null" class="money" :style="'color: '+GetColorMain()">立减 <span>{{ item.discountPrice.toFixed(2) }}</span>元</div>
                    <span v-if="item.lowLimitPrice!==null">指定商品满{{ item.lowLimitPrice.toFixed(2) }}元可用</span>
                    <span v-if="item.limitMax!==null">限购{{ item.limitMax }}件</span>
                  </van-col>
                  <van-col span="14" offset="1">
                    <div class="name">
                      {{ item.title }}
                    </div>
                    {{ formatDate(item.dtStar,"yyyy/MM/dd",false) }}
                    -
                    {{ formatDate(item.dtEnd,"yyyy/MM/dd",false) }}
                  </van-col>
                  <van-col span="2">
                    <van-checkbox :key="item.couponId" :name="item.couponId" :disabled="!item.isEnable || loadingCoupon" class="selectButton" :checked-color="GetColorMain()" />
                  </van-col>
                </van-row>
                <div class="about">
                  {{ item.remark }}
                </div>
              </div>
            </van-checkbox-group>
            <div class="button">
              <van-button round type="danger" :color="GetColorMain()" @click="showCoupon=false">确定</van-button>
            </div>
          </van-tab>
          <van-tab :title="'不可用优惠券('+couponData.disableList.length+')'" name="notavailable">
            <div v-for="item in couponData.disableList" :key="item.couponId" class="rect disbale">
              <van-row class="infos">
                <van-col span="7">
                  <div v-if="item.discountPercentage!==null" class="money" :style="'color: '+GetColorMain()"><span>{{ (item.discountPercentage*0.1).toFixed(1) }}</span>折</div>
                  <div v-if="item.realPrice!==null" class="money" :style="'color: '+GetColorMain()"><span>{{ item.realPrice.toFixed(2) }}</span>元</div>
                  <div v-if="item.discountPrice!==null" class="money" :style="'color: '+GetColorMain()">立减 <span>{{ item.discountPrice.toFixed(2) }}</span>元</div>
                  <span v-if="item.lowLimitPrice!==null">指定商品满{{ item.lowLimitPrice.toFixed(2) }}元可用</span>
                  <span v-if="item.limitMax!==null">限购{{ item.limitMax }}件</span>
                </van-col>
                <van-col span="14" offset="1">
                  <div class="name">
                    {{ item.title }}
                  </div>
                  {{ formatDate(item.dtStar,"yyyy/MM/dd",false) }}
                  -
                  {{ formatDate(item.dtEnd,"yyyy/MM/dd",false) }}
                </van-col>
              </van-row>
              <div class="about">
                {{ item.remark }}
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
    <diySelect v-model="showDiySelect" :specification-id="selectDiyId" @onChange="onDiyDataChange" />
    <selectContacts v-model="showContactsSelectNum" :list="contactsSelectList" @select="onSelectContacts" />
    <van-popup v-model="showDatePlanSelect" position="bottom">
      <van-nav-bar
        title="请选择出行日期"
        left-text="返回"
        right-text="确定"
        left-arrow
        @click-left="onCloseDatePlan"
        @click-right="onDatePlanSelectDate"
      />
      <calendarDatePlanSelect v-model="datePlaySelectSpecificationId" :commodity-id="datePlaySelectCommodiyId" :begin-date="datePlaySelectDate" @select="onDatePlanSelect" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Switch, Popup, Picker, Tag, Tab, Tabs, Checkbox, CheckboxGroup, Field, ImagePreview, Dialog, NavBar } from 'vant'
import TopBar from '@/components/TopBar'
import { checkIsInAlipay, cutString, MyNotify, ShowMoney, getUrlKey, formatDate, UrlBase64 } from '@/utils/base'
import commondata from '@/commondata.js'
import { GetProfitsharingStore, GetProfitsharingAgent, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getToken } from '@/utils/auth'
import diySelect from '@/components/diySelect'
import calendarDatePlanSelect from '@/components/calendarDatePlanSelect'
import selectContacts from '@/components/selectContacts'
import { CheckSystemType } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [ImagePreview.name]: ImagePreview,
    [Dialog.name]: Dialog,
    [NavBar.name]: NavBar,
    TopBar,
    diySelect,
    calendarDatePlanSelect,
    selectContacts
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      system: undefined,
      title: '我的订单',
      backurl: '/my/index',
      checkedScore: false,
      loadingButton: false,
      loadingCoupon: false,
      isStepBuy: false,
      data: {
        commodityPrice: undefined,
        freightPrice: undefined,
        reductionPrice: undefined,
        couponPrice: undefined,
        scorePrice: undefined,
        payPrice: 0,
        payPriceProportion: 0
      },
      couponData:
      {
        disableList: [],
        list: [],
        totalCouponNum: 0,
        totalCouponPrice: 0
      },
      commData: [],
      selectAdressId: undefined,
      address: undefined,
      showPayType: false,
      columnsPayType: [],
      selectPayType: undefined,
      showCoupon: false,
      couponType: 0,
      radioCoupon: [],
      selectCouponPrice: 0,
      selectCouponCommodityNum: 0,
      orderRemark: '',
      needFerightPrice: false,
      isActivity: false,
      selectDiyId: undefined,
      showDiySelect: false,

      showDatePlanSelect: false,
      datePlaySelectSpecificationId: undefined,
      datePlaySelectCommodiyId: undefined,
      datePlanSelectValueLs: undefined,
      datePlaySelectDate: undefined,
      selectCommodityIndex: undefined,

      showContactsSelectNum: 0,
      contactsSelectList: [],
      payChannelList: []
    }
  },
  created() {
    this.system = getUrlKey('system')
    var data = getUrlKey('data')
    if (getUrlKey('activity')) {
      this.isActivity = true
    }
    console.log('传递来的数据', data)
    this.commData = []
    var items = data.split('|')
    const num = 8
    for (var i = 0; i < Math.floor(items.length / num); i++) {
      this.commData.push({
        id: items[i * num + 0],
        num: items[i * num + 1],
        specificationMain: items[i * num + 2],
        specificationOther: items[i * num + 3],
        diyData: items[i * num + 4],
        carId: items[i * num + 5],
        tripBeginTime: items[i * num + 6],
        tripEndTime: items[i * num + 7],
        customerLogIds: []
      })
    }
    console.log('处理后的数据', this.commData)
    console.log('dizhi', commondata.selectAddress)
    if (commondata.selectAddress) {
      this.selectAdressId = commondata.selectAddress.id
    } else {
      this.selectAdressId = undefined
    }
    this.getPayChannelList(() => {
      this.onInitAddress(() => {
        this.onInit(() => {
          this.onInitCoupon(true, () => {
            if (this.isActivity) {
              if (this.needFerightPrice) {
                var body
                if (this.data.freightStrategy === 'FULL_AMOUNT_FREE') {
                  body = '购满' + ShowMoney(this.data.LowFreeFreigthValue) + '元免运费，是否要去凑单?'
                } else if (this.data.freightStrategy === 'FULL_PIECE_FREE') {
                  body = '购满' + parseInt(this.data.LowFreeFreigthValue) + '件免运费，是否要去凑单?'
                }
                if (body) {
                  Dialog.confirm({
                    title: '凑单包邮',
                    message: body,
                    confirmButtonText: '凑单'
                  }).then(() => {
                    request({
                      url: '/StoreHelper/addShoppingCarActivity',
                      method: 'post',
                      data: {
                        commodityId: this.commData[0].id,
                        SpecificationMainId: this.commData[0].specificationMain,
                        SpecificationOtherIds: this.commData[0].specificationOther,
                        num: this.commData[0].num,
                        diyTitle: this.commData[0].diyData ? JSON.parse(this.commData[0].diyData).title : undefined,
                        diyInfo: this.commData[0].diyData
                      }
                    })
                    Dialog.alert({
                      title: '凑单包邮',
                      message: '选购凑单商品到购物车后，即可一起结算。'
                    }).then(() => {
                      this.$router.push('/store/index/')
                    })
                  }).catch(() => {
                    if (this.data.commoditys[0].diyType !== 'NONE' && !this.data.commoditys[0].diyData) {
                      Dialog.alert({
                        title: '完善定做信息',
                        message: '您要结算的商品中有需要完善信息个定制产品，请先完善!',
                        confirmButtonText: '完善信息'
                      }).then(() => {
                        this.selectDiyId = this.data.commoditys[0].specificationMain
                        this.showDiySelect = true
                      })
                    }
                  })
                }
              }
            }
          })
        })
      })
    })
  },
  methods: {
    cutString,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    formatDate,
    CheckSystemType,
    getPayChannelList(callback) {
      this.columnsPayType = []
      this.selectPayType = undefined
      request({
        url: '/Store/GetPAYChannel',
        method: 'post',
        data: {
          isSystem: CheckSystemType('SSI')
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.payChannelList = response.data
        if (callback) {
          callback()
        }
        // 支付宝临时处理去除微信支付
        if (checkIsInAlipay()) {
          this.payChannelList = this.payChannelList.filter(el => el.name.indexOf('微信') < 0)
        }
        // 支付宝临时处理去除微信支付 -结束
        this.payChannelList.forEach(el => {
          el.text = el.name
          el.value = el.moneyChannelId
          this.columnsPayType.push(el)
        })
        if (this.payChannelList.length > 0) {
          this.selectPayType = this.payChannelList[0]
        }
      })
    },
    onDiyDataChange(data) {
      console.log('定做信息', data)
      this.data.commoditys[0].diyData = data
      this.commData[0].diyData = JSON.stringify(data)
    },
    checkOrderData() {
      for (var i = 0; i < this.data.commoditys.length; i++) {
        var commodity = this.data.commoditys[i]
        if (commodity.isNeedContacts) {
          if (!this.commData[i].tripBeginTime) {
            MyNotify('info', '请选择“' + commodity.name + '”的出行日期!')
            return false
          }
          if (this.commData[i].customerLogIds === null || this.commData[i].customerLogIds.length !== commodity.num) {
            MyNotify('info', '请选择“' + commodity.name + '”的' + commodity.num + '名出行人!')
            return false
          }
        }
      }
      return true
    },
    onSubmitOrder() {
      if (CheckSystemType('SSI')) {
        if (!GetProfitsharingStore() || !GetProfitsharingAgent()) {
          Dialog.alert({
            title: '商城尚未激活',
            message: '请联系您所在的潜水中心激活商城后才可以下单购买商品!'
          }).then(() => {
            return
          })
          return
        }
      }
      console.log("this.data.isAllVirtually",this.data.isAllVirtually)
      if (!this.data.isAllVirtually) {
        if (this.data.needAddress) {
          this.onAddressChange(false)
          return
        }
      }
      if (!this.checkOrderData()) {
        return
      }
      this.loadingButton = true
      var orderData = {
        moneyChannelId: this.selectPayType.value,
        addressId: this.selectAdressId,
        score: 0,
        couponId: this.radioCoupon,
        list: this.commData,
        remark: this.orderRemark,
        freightStrategy: this.data.freightStrategy
      }
      console.log('提交订单', orderData)
      request({
        url: '/Store/OrderCreate',
        method: 'post',
        data: orderData
      }).then(response => {
        this.loadingButton = false
        if (!response.success) {
          return
        }
        console.log('订单提交成功', response.data)
        this.$router.push('/store/pay/' + response.data.orderId)
      })
    },
    CalculationTotalPrice() {
      if (!this.isStepBuy) {
        // this.data.freightPrice -
        var price = this.data.commodityPrice -
          this.data.reductionPrice -
          this.data.couponPrice -
          this.data.scorePrice +
          this.data.agentPrice

        this.data.totalPriceFreight = price
        this.needFerightPrice = true
        if (this.data.freightStrategy === 'FULL_AMOUNT_FREE') {
          this.needFerightPrice = this.data.totalPriceFreight < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'FULL_PIECE_FREE') {
          this.needFerightPrice = this.data.totalNum < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'NONE') {
          this.needFerightPrice = false
        }

        var freightPrice = this.needFerightPrice ? this.data.freightPrice : 0
        if (this.selectPayType.chargesPercentage > 0) {
          this.data.payPrice = parseFloat(((price + freightPrice) * this.selectPayType.chargesPercentage).toFixed(2))
        } else {
          this.data.payPrice = 0
        }
        // /是否免收支付手续费
        if (this.selectPayType.isFreePayPrice) {
          this.data.totalPrice = price + freightPrice
        } else {
          this.data.totalPrice = price + this.data.payPrice + freightPrice
        }
        return
      }
      if (this.data.commoditys[0].stepBuy === 'SECOND_CNY') {
        var price1Step = this.data.commoditys[0].stepPrice * this.data.commoditys[0].num
        var price1 = this.data.commodityPrice -
          this.data.reductionPrice -
          this.data.couponPrice -
          this.data.scorePrice +
          this.data.agentPrice
        this.data.totalPriceFreight = price1
        // console.log('price1', price1)
        // 计算分批购商品所有金额
        this.needFerightPrice = true
        if (this.data.freightStrategy === 'FULL_AMOUNT_FREE') {
          this.needFerightPrice = this.data.totalPriceFreight < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'FULL_PIECE_FREE') {
          this.needFerightPrice = this.data.totalNum < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'NONE') {
          this.needFerightPrice = false
        }
        var freightPrice1 = this.needFerightPrice ? this.data.freightPrice : 0
        if (this.selectPayType.chargesPercentage > 0) {
          this.data.payPrice = parseFloat((price1Step * this.selectPayType.chargesPercentage).toFixed(2))
        } else {
          this.data.payPrice = 0
        }
        // 是否免收支付手续费
        if (this.selectPayType.isFreePayPrice) {
          this.data.payPrice = 0
        }
        this.data.totalPrice = price1Step + this.data.payPrice
        // console.log('this.data.totalPrice', this.data.totalPrice)
        var t = price1 + freightPrice1
        var p = 0
        if (this.selectPayType.chargesPercentage > 0) {
          p = parseFloat((t * this.selectPayType.chargesPercentage).toFixed(2))
        }
        // 是否免收支付手续费
        if (this.selectPayType.isFreePayPrice) {
          p = 0
        }
        this.data.payPriceTotal = p
        this.data.totalPriceForAll = t + p
      } else if (this.data.commoditys[0].stepBuy === 'SECOND_OTHER') {
        var price2 = this.data.commodityPrice -
          this.data.reductionPrice -
          this.data.couponPrice -
          this.data.scorePrice +
          this.data.agentPrice
        this.data.totalPriceFreight = price2

        this.needFerightPrice = true
        if (this.data.freightStrategy === 'FULL_AMOUNT_FREE') {
          this.needFerightPrice = this.data.totalPriceFreight < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'FULL_PIECE_FREE') {
          this.needFerightPrice = this.data.totalNum < this.data.LowFreeFreigthValue
        } else if (this.data.freightStrategy === 'NONE') {
          this.needFerightPrice = false
        }

        var freightPrice2 = this.needFerightPrice ? this.data.freightPrice : 0
        if (this.selectPayType.chargesPercentage > 0) {
          this.data.payPrice = parseFloat(((price2 + freightPrice2) * this.selectPayType.chargesPercentage).toFixed(2))
        } else {
          this.data.payPrice = 0
        }
        // 是否免收支付手续费
        if (this.selectPayType.isFreePayPrice) {
          this.data.payPrice = 0
        }
        this.data.payPriceTotal = this.data.payPrice
        this.data.totalPrice = price2 + this.data.payPrice + freightPrice2
        return
      }
      // console.log('data', this.data)
      // var realCommodityPrice = this.data.commodityPrice
      // var realCoupon = this.data.couponPrice

      // if (this.isStepBuy && this.data.commoditys[0].stepBuy === 'SECOND_CNY') {
      //   realCommodityPrice = this.data.commoditys[0].stepPrice * this.data.commoditys[0].num
      //   realCoupon = 0
      // } else if (this.isStepBuy && this.data.commoditys[0].stepBuy === 'SECOND_OTHER') {
      //   realCommodityPrice = this.data.commoditys[0].price * this.data.commoditys[0].num
      // }
      // var price = realCommodityPrice +
      //   this.data.freightPrice -
      //   this.data.reductionPrice -
      //   realCoupon -
      //   this.data.scorePrice
      // var totalPrice = this.data.commodityPrice +
      //   this.data.freightPrice -
      //   this.data.reductionPrice -
      //   realCoupon -
      //   this.data.scorePrice

      // if (this.isStepBuy && this.data.commoditys[0].stepBuy === 'SECOND_CNY') {
      //   price = realCommodityPrice
      // }

      // if (this.selectPayType.value === 'WECHAT_PAY') {
      //   this.data.payPrice = parseFloat((price * this.data.payPriceProportion).toFixed(2))
      // } else {
      //   this.data.payPrice = 0
      // }
      // this.data.totalPrice = price + this.data.payPrice
    },
    onInitCoupon(getDefault, callback) {
      this.loadingCoupon = true
      request({
        url: '/StoreHelper/getCouponList',
        method: 'post',
        data: {
          list: this.commData,
          getDefault: getDefault,
          selectCoupon: this.radioCoupon
        }
      }).then(response => {
        if (!response.success) {
          this.loadingCoupon = false
          return
        }
        console.log('优惠券信息', response.data)
        this.couponData = response.data
        this.radioCoupon = []
        this.couponData.list.map((item) => {
          if (item.isSelect) {
            this.radioCoupon.push(item.couponId)
          }
        })
        this.data.couponPrice = this.couponData.totalCouponPrice
        this.CalculationTotalPrice()
        setTimeout(() => {
          this.loadingCoupon = false
        }, 100)
        if (callback) {
          callback()
        }
      })
    },
    onCouponChange() {
      console.log(' this.radioCoupon', this.radioCoupon)
      if (!this.loadingCoupon) {
        this.onInitCoupon(false)
      }
      // this.selectCouponPrice = 0
      // this.selectCouponCommodityNum = 0
      // this.couponData.list.map((item) => {
      //   if (this.radioCoupon.find((id) => id === item.couponId)) {
      //     this.selectCouponPrice += item.discountPrice * item.commoditys[0].num
      //     this.selectCouponCommodityNum += item.commoditys[0].num
      //   }
      // })
      // console.log('selectCouponPrice', this.selectCouponPrice)
      // this.data.couponPrice = this.selectCouponPrice
      // this.CalculationTotalPrice()
    },
    onInit(callback) {
      request({
        url: '/Store/getOrderCreateInfo',
        method: 'post',
        data: { list: this.commData,
          couponId: undefined,
          moneyChannelId: this.selectPayType.value,
          addressId: this.selectAdressId,
          score: 0
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.isStepBuy = this.data.commoditys.length === 1 && this.data.commoditys[0].stepBuy !== 'NONE'
        this.data.commoditys.forEach(item => {
          if (item.diyData) {
            item.diyData = JSON.parse(item.diyData)
          }
          item.isNeedContacts = item.commodityType === 'SCHEDULING' || item.commodityType === 'COURSE'
        })
        console.log('数据', this.data)
        if (callback) {
          callback()
        }
      })
    },
    onInitAddress(callback) {
      request({
        url: '/StoreHelper/getUserAddress',
        method: 'post',
        params: { addressId: this.selectAdressId }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data) {
          this.address = response.data
          this.selectAdressId = this.address.addressId
        } else {
          this.address = undefined
          this.selectAdressId = undefined
        }
        if (callback) {
          callback(this.address)
        }
      })
    },

    onAddressChange(isHave) {
      if (isHave) {
        this.$router.push('/store/addressList')
      } else {
        this.$router.push('/store/addressEdit')
      }
    },
    onCancel() {
      this.showPayType = false
    },
    onSelectPayType() {
      this.showPayType = true
    },
    onConfirmPayType(value) {
      this.showPayType = false
      this.selectPayType = value
      this.CalculationTotalPrice()
    },
    onShowCoupon() {
      this.showCoupon = true
    },
    showCommoditysIcon(data) {
      console.log('showCommoditysIcon', data)
      if (data.diyType === 'NONE' || !data.diyIcon) {
        return data.icon
      }
      var url = data.diyIcon +
        '?specificationId=' + data.specificationMain +
        '&nickName=' + encodeURIComponent(data.diyData.nickName) +
        '&certificateTeam=' + encodeURIComponent(data.diyData.certificateTeam) +
        '&certificateId=' + encodeURIComponent(data.diyData.certificateId) +
        '&extendedData=' + (data.diyData.extendedData ? encodeURIComponent(data.diyData.extendedData) : '') +
        '&token=' + UrlBase64(getToken())
      return url
    },
    onShowItemOrImage(data) {
      console.log('onShowItemOrImage', data)
      if (data.diyType === 'NONE' || !data.diyIcon) {
        this.onShowItem(data.commodityId)
      } else {
        if (data.diyType === 'CIRCULAR_SEAL') {
          ImagePreview([
            this.showCommoditysIcon(data)
          ])
        } else if (data.diyType === 'CARD') {
          var url = this.showCommoditysIcon(data)
          ImagePreview([
            url + '&id=0',
            url + '&id=1'
          ])
        }
      }
    },
    // 选择数据回调
    onDatePlanSelect(date) {
      this.datePlanSelectValueLs = date
    },
    // 确认选择
    onDatePlanSelectDate() {
      if (!this.datePlanSelectValueLs) {
        MyNotify('success', '请选择出行日期', 3000)
        return
      }
      console.log('date', this.datePlanSelectValueLs)
      this.data.commoditys[this.selectCommodityIndex].tripBeginTime = this.datePlanSelectValueLs
      this.commData[this.selectCommodityIndex].tripBeginTime = formatDate(this.datePlanSelectValueLs, 'yyyy/MM/dd')
      this.onCloseDatePlan()
    },
    onCloseDatePlan() {
      this.datePlanSelectValueLs = undefined
      this.showDatePlanSelect = false
    },
    onClickDatePlan(index, data) {
      this.selectCommodityIndex = index
      console.log('onClickDatePlan', data)
      this.datePlanSelectValueLs = undefined
      this.showDatePlanSelect = true
      setTimeout(() => {
        this.datePlaySelectCommodiyId = data.commodityId
        console.log('data.tripBeginTime', data.tripBeginTime)
        this.datePlaySelectDate = data.tripBeginTime
        this.datePlanSelectValueLs = new Date(data.tripBeginTime)
      }, 20)
      setTimeout(() => {
        this.datePlaySelectSpecificationId = data.specificationMain
      }, 21)
    },
    onClickContacts(index, data) {
      console.log('onClickDatePlan', data)
      this.selectCommodityIndex = index
      this.showContactsSelectNum = data.num
      // 设定已选中项目
      var list = this.commData[this.selectCommodityIndex].customerLogIds
      if (list && list.length > 0) {
        this.contactsSelectList = JSON.parse(JSON.stringify(list))
      } else {
        this.contactsSelectList = []
      }
    },
    onSelectContacts(list) {
      // customerLogIds
      console.log('onSelectContacts', this.selectCommodityIndex)
      this.commData[this.selectCommodityIndex].customerLogIds = []
      this.data.commoditys[this.selectCommodityIndex].customerInfo = list
      list.forEach(item => {
        this.commData[this.selectCommodityIndex].customerLogIds.push(item.customerLogId)
      })
      console.log('onSelectContacts', this.commData[this.selectCommodityIndex].customerLogIds)
    },
    onClickRemoveCustomer(index, id) {
      console.log('onClickRemoveCustomer', index + ' ' + id)
      this.data.commoditys[index].customerInfo = this.data.commoditys[index].customerInfo.filter(item => item.customerLogId !== id)
      this.data.commoditys = JSON.parse(JSON.stringify(this.data.commoditys))
      this.commData[index].customerLogIds = this.commData[index].customerLogIds.filter(item => item !== id)
      console.log(' this.commData[index].customerLogIds', this.data.commoditys[index].customerInfo)
    }
  }
}
</script>

<style scoped>
.body{
  /* padding: 0.5em; */
}
.addressRect{
  background-color: #fff;
  position: relative;
  padding: 0.5em 0.5em 1em 0.5em;
}
.addressRect .name{
  font-weight: 700;
  padding-right: 1em;
  line-height: 2em;
}
.addressRect .address{
  font-size: 0.9em;
  padding-right: 1em;
}
.addressRect  .button{
  position: absolute;
  right: 0.5em;
  top:1.5em;
}
.addressRect .input{
  padding-right: 1em;
  line-height: 3em;
}
.addressRect::before {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height:3px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 20vw;
  content: '';
}

.payType{
   background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
   line-height: 2.5em;
}
.commoditys{
   background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
}
.commoditys .title{
  padding: 0.8em 0 1.3em 0;
}
.commoditys .num{
  line-height: 3.4em;
}
.traffic{
   background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
   line-height: 2em;
}
.gifts{
   background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
   line-height: 2em;
}
.remark{
   background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
   line-height: 44px;
}
.price{
  background-color: #fff;
   padding: 0.5em;
   margin-top: 0.8em;
   line-height: 1.8em;
}
.emptyRect{
  height: 4em;
}
.toolBar{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  background-color: #fff;

}
.toolBar .priceAll{
  padding-left: 0.5em;
  line-height: 3em;
  font-size: 1em;
  font-weight: 700;
  color:#f00;
}

.toolBar .priceAll span{
  font-size: 1.2em;
}
.addressSelect{
  position: absolute;
  left: 0;
  right: 0;
  top:-1.5em;
  height: 1.5em;
  font-size: 0.9em;
  line-height: 1.5em;
  padding-left: 0.5em;
  background-color: #ff0;
  color: #660;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.commodityRect
{
  position: relative;
}
.commodityRect .info
{
  position: absolute;
  left: 4.5em;
  top: -0.2em;
  right: 1em;
  bottom: 0;
}

.commodityRect .info .name{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.commodityRect .info .specification{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 0.8em;
  color: #999;
  line-height: 2.4em;
}

.commodityRect .info .priceItem
{
  font-size: 0.8em;
  font-weight: 700;
  color:#f00;
}
.commodityRect .info .priceItem span{
  font-size: 1.2em;
}
.couponRect{

}
.couponRect .title{
  padding: 1em 0.5em;
}

.couponRect .tips{
  background-color: #FFF0DB;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  font-size: 0.9em;
  line-height: 2em;
  padding: 0 0.5em;
  height: 2em;
}
.couponRect .listAvailable{
  height: 21em;
  overflow-y:auto;
  background-color: #F8F8F8;
}
.couponRect .list{
  height: 26.55em;
  overflow-y:auto;
  background-color: #F8F8F8;
}
.couponRect .button{
text-align: center;
padding: 0.5em 0;
}
.couponRect .button button{
  width: 60%;
  height: 3em;
  line-height: 3em;
}

.couponRect .rect
{
  background-color: #fff;
  margin:1em;
  font-size: 0.9em;
  color: #999;
  border-radius: 0.4em;
  -moz-box-shadow:0px 0px 5px #cacaca;
   -webkit-box-shadow:0px 0px 5px #cacaca;
    box-shadow:0px 0px 5px #cacaca;
}
.couponRect .rect .infos{
  padding: 1em 0 1em 1em;
}
.couponRect .disbale{
  background-color: #eaeaea;
}
.couponRect .rect .infos .money{
  padding-bottom:0.3em;
}
.couponRect .rect .infos .money span{
  font-size: 1.2em;
  font-weight: 700;
}
.couponRect .rect .infos .name{
  color: #000;
  font-size: 1.2em;
  padding-bottom:0.3em;

}
.couponRect .rect .about
{
  border-top: 1px dotted #cacaca;
  padding:0.5em 1em;
  background-color: #F8F8F8;
}
.couponRect .rect .selectButton{
  margin-top:1.5em;
}
.freePayPrice{
  font-size: 0.7em;
  color: #999;
}
.aboutStr{
  color: #999;
  font-size: 0.8em;
  line-height: 1.3em;
}
.stepPayRect{
  position: relative;
  height: 3.6em;
}
.stepPayRect .stepPayIconRect
{
  position: absolute;
  left: 0;
  top: 0;
}
.stepPayRect .stepPayInfoRect{
  position: absolute;
  left: 1.2em;
  top: 0;
  right: 0;
  height: 3.6em;
  line-height: 1.8em;
}
.stepPayRect .stepPayInfoRect div{
  font-size: 0.9em;
}
.stepPayRect span{
  color: #999;
}
.stepPayRect .stepPayInfoRect .payState
{
  color: #999;
}
.stepPayRect .stepPayIconRect .stepPayLine{
  position: absolute;
  width: 1px;
  height: 0.8em;
  background-color: #dadada;
  left: 0.4em;
  top:1.4em;
}
.stepPayRect .stepPayIconRect .stepPayIcon1{
  position: absolute;
  width: 0.8em;
  height: 0.8em;
  background-color: #dadada;
  border-radius: 1em;
  left: 0;
  top:0.5em;
}
.stepPayRect .stepPayIconRect .stepPayIcon2{
  position: absolute;
  width: 0.8em;
  height: 0.8em;
  background-color: #dadada;
  border-radius: 1em;
  left: 0;
  top:2.3em;
}
.extebdedRect{
  font-size: 0.9em;
  line-height: 30px;
   border-bottom: 1px solid #cacaca;
   margin: 1em 0 1.5em 0;
}

.extebdedRect .line{
  padding:0.5em 0;
  border-top: 1px solid #eaeaea;
}
.extebdedRect .line i{
  margin-right: 0.1em;
  font-size: 1.5em;
}
</style>

<style>
.van-calendar__header-title{
  display: none;
}
.van-calendar__month-title{
  display: none;
}
.van-calendar__header{
  box-shadow:none;
  border-bottom: 1px solid #ccc;
}
</style>
